













import { Vue, Component, Prop } from 'vue-property-decorator'
import { Schedule } from '@/types/schedule'
import UserIcon from '../common/UserIcon.vue'
import ScheduleTypeIcon from './ScheduleTypeIcon.vue'
import dayjs from 'dayjs'
import { eventType2Css } from '@/utils/schedule'
import { ScheduleEventType } from '@/constants/schedule'

@Component({
  components: { UserIcon, ScheduleTypeIcon }
})
export default class CalendarItem extends Vue {
  @Prop({ default: '' })
  date!: string

  @Prop({ default: '2020-01-01' })
  today!: string

  @Prop({ default: {} })
  schedule!: Schedule

  get eventTypeCss() {
    return eventType2Css(
      (this.schedule.eventType || '').trim() as ScheduleEventType
    )
  }

  get startTime() {
    const { startHour, startMinute } = this.schedule
    return `${('0' + startHour).slice(-2)}:${('0' + startMinute).slice(-2)}`
  }

  get patient() {
    return this.schedule.patient
  }

  get patientName() {
    return `${this.patient.lastName}${this.patient.firstName}`
  }
}
